import styled from 'styled-components/macro';
import { GlobalColors, Rules } from './Globals';
import { row_center_both } from './styles-helpers';

export const LsButton = styled.button`
	user-select: none;
	border: none;
	box-shadow: none;
	cursor: pointer;
	${row_center_both}
	gap: 0.2rem;
	font-weight: bold;
	text-align: center;
	background: ${GlobalColors.desaturatedBtn};
	color: ${GlobalColors.activeTabs};
	border-radius: ${Rules.radiusButtonCTA};
	padding: 0.5rem;
	img,
	svg {
		max-width: 16px;
		max-height: 16px;
	}
`;
